(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-day-calculator"] && !Shopify.designMode) return;
  try {
    function initialiseDeliveryCalculators() {
    document
      .querySelectorAll('[data-delivery-calculator]')
      .forEach((calculator) => {
        if (calculator.dataset.initialised === 'true') return;

        calculator.dataset.initialised = 'true';

        const orderDay = calculator.querySelector('[data-order-day]');
        const leadTime = calculator.querySelector('[data-lead-time]');
        const orderTimes = calculator.querySelectorAll('[data-order-time]');
        const result = calculator.querySelector('[data-delivery-result]');

        const days = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ];

        function normaliseOrderDay(day) {
          if (day === 6 || day === 0) {
            return 1;
          }

          return day;
        }

        function getNextBusinessDay(day) {
          let nextDay = day;

          do {
            nextDay = (nextDay + 1) % 7;
          } while (nextDay === 0 || nextDay === 6);

          return nextDay;
        }

        function calculateDeliveryDay(startDay, targetDay) {
          let currentDay = startDay;
          let businessDaysCounted = 1;

          while (businessDaysCounted < targetDay) {
            currentDay = getNextBusinessDay(currentDay);
            businessDaysCounted++;
          }

          return currentDay;
        }

        function updateDeliveryDay() {
          const selectedOrderDay = Number(orderDay.value);
          const targetDay = Number(leadTime.value);
          const selectedOrderTime = calculator.querySelector(
            '[data-order-time]:checked'
          ).value;

          let startDay = normaliseOrderDay(selectedOrderDay);

          if (
            selectedOrderTime === 'after' &&
            selectedOrderDay !== 0 &&
            selectedOrderDay !== 6
          ) {
            startDay = getNextBusinessDay(startDay);
          }

          const deliveryDay = calculateDeliveryDay(
            startDay,
            targetDay
          );

          result.textContent = days[deliveryDay];
        }

        orderDay.addEventListener('change', updateDeliveryDay);
        leadTime.addEventListener('change', updateDeliveryDay);

        orderTimes.forEach((orderTime) => {
          orderTime.addEventListener('change', updateDeliveryDay);
        });

        updateDeliveryDay();
      });
  }

  initialiseDeliveryCalculators();

  document.addEventListener(
    'shopify:section:load',
    initialiseDeliveryCalculators
  );
  } catch(e) { console.error(e); }
})();

})();
